import React, { useEffect, useRef } from 'react';
import ZaggerLogo from './ZaggerLogo';
import './ProjectsHeader.css';
const ProjectsHeader = ({
  isMenuOpen,
  onToggle,
  title = '',
  rightContent = null,
}) => {
  const headerRef = useRef(null);

  // Keep a CSS variable --header-height in sync with the actual header height,
  // so pages can size their content to viewport minus the header.
  useEffect(() => {
    const el = headerRef.current;
    if (!el) return;
    const setVar = () => {
      const h = el.offsetHeight || 72;
      try {
        document.documentElement.style.setProperty('--header-height', `${h}px`);
      } catch (_) {}
    };
    let rafId = null;
    const scheduleSetVar = () => {
      if (rafId != null) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        rafId = null;
        setVar();
      });
    };
    setVar();
    window.addEventListener('resize', scheduleSetVar);
    let ro;
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(scheduleSetVar);
      try { ro.observe(el); } catch (_) {}
    }
    return () => {
      window.removeEventListener('resize', scheduleSetVar);
      if (rafId != null) cancelAnimationFrame(rafId);
      if (ro) try { ro.disconnect(); } catch (_) {}
    };
  }, [isMenuOpen, title]);

  const isBrandTitle = !title || String(title).trim().toLowerCase() === 'zagger';

  return (
    <header ref={headerRef} className={`projects-header ${isMenuOpen ? 'menu-open' : ''}`}>
      <div className="header-content">
        <div className="header-left-cluster">
          <button
            className="header-menu-toggle"
            onClick={onToggle}
            aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>        <div className="header-brand">
          {isBrandTitle ? (
            <ZaggerLogo variant="full" className="header-title-logo" />
          ) : (
            <>
              <ZaggerLogo variant="mark" />
              <h1 className="header-title">{title}</h1>
            </>
          )}
        </div>
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
          {rightContent}
        </div>
      </div>
    </header>
  );
};

export default ProjectsHeader;
